import React, {useState} from "react";
import axios from "axios";
import LoadingButton from "@mui/lab/LoadingButton";
import ReceiptIcon from "@mui/icons-material/Receipt";

export default function DownloadButton({
                                           url, filename,
                                           filter,
                                           buttonText = "Baixar relatório",
                                           className, icon = <ReceiptIcon/>,
                                           variant = "contained"
                                       }) {

    const [loading, setLoading] = useState(false)


    const handleClick = () => {
        setLoading(true)

        let requestUrl = url;

        if (filter) {
            const queryParams = new URLSearchParams(filter).toString();
            requestUrl = `${url}?${queryParams}`
        }

        const axiosConfig = {
            method: 'get',
            url: requestUrl,
            responseType: 'blob'
        };

        // Realiza a requisição Axios
        axios(axiosConfig)
            .then(response => {
                // Cria um objeto URL para o blob
                const blobUrl = URL.createObjectURL(response.data);

                // Cria um link para download
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = filename;

                // Adiciona o link ao corpo do documento
                document.body.appendChild(link);

                // Simula um clique no link para iniciar o download
                link.click();

                // Remove o link do corpo do documento após o download
                document.body.removeChild(link);
            })
            .catch(error => console.error('Erro ao gerar relatório:', error))
            .finally(() => {
                setLoading(false)
            })
    }


    return buttonText ?
        <LoadingButton
            onClick={handleClick}
            loading={loading}
            loadingPosition={"start"}
            startIcon={icon}
            variant={variant}
            className={className}
        >
        <span>
            &nbsp;{buttonText ? buttonText : icon}
        </span>
        </LoadingButton> :
        <LoadingButton
            onClick={handleClick}
            loading={loading}
            variant={variant}
            className={className}
        >
            {icon}
        </LoadingButton>
}